// GENERATED BY JsGenerators::WorkMetadata! DO NOT EDIT!

Works.SECTIONS = {
"Books":{
"noun":"book",
"doc_type":"book",
"suggested_fields":["abstract","more_info","publication_date","publisher"],
"og_icon":"open-graph-icons/fb-book.gif",
"og_type":"book"
},
"Papers":{
"noun":"paper",
"doc_type":"paper",
"suggested_fields":["abstract","more_info","publication_name","publication_date"],
"og_icon":"open-graph-icons/fb-paper.gif",
"og_type":"article"
},
"Talks":{
"noun":"talk",
"doc_type":"talk",
"suggested_fields":["abstract","organization","location","time","event_date"],
"og_icon":"open-graph-icons/fb-talk.gif",
"og_type":"article"
},
"Teaching Documents":{
"noun":"teaching document",
"doc_type":"teaching_document",
"suggested_fields":["more_info","abstract","location","event_date"],
"og_icon":"open-graph-icons/fb-teaching.gif",
"og_type":"article"
},
"Drafts":{
"noun":"draft",
"doc_type":"draft",
"suggested_fields":["abstract","more_info"],
"og_icon":"open-graph-icons/fb-paper.gif",
"og_type":"article"
},
"Book Reviews":{
"noun":"book review",
"doc_type":"book_review",
"suggested_fields":["abstract","more_info","publication_name","publication_date"],
"og_icon":"open-graph-icons/fb-paper.gif",
"og_type":"article"
},
"Conference Presentations":{
"noun":"conference presentation",
"doc_type":"conference_presentation",
"suggested_fields":["abstract","journal_name","location","time","event_date"],
"og_icon":"open-graph-icons/fb-paper.gif",
"og_type":"article"
},
"Thesis Chapters":{
"noun":"thesis chapter",
"doc_type":"thesis_chapter",
"suggested_fields":["abstract","more_info","completion_date"],
"og_icon":"open-graph-icons/fb-paper.gif",
"og_type":"article"
},
"Other":{
"noun":"document",
"doc_type":"other",
"suggested_fields":["abstract","more_info","publication_name","publication_date"],
"og_icon":"open-graph-icons/fb-paper.gif",
"og_type":"article"
}
};
